import { useContext } from 'react';
import RouterContext from 'app/context/router';

export default () => useContext(RouterContext);
